
import React from 'react';
import { useIntl } from 'react-intl';
import { ReactComponent as SparkIcon } from 'Images/spark_icon.svg';

import PromptCopyCard from '../PromptCopyCard';

import {
  Wrapper,
  IntroText
} from './styled';

const VerifyConnectionSection = () => {
  const intl = useIntl();
  const prompt = `"${intl.formatMessage({ id: 'mcp.verify.prompt' })}"`;

  return (
    <Wrapper>
      <IntroText>{intl.formatMessage({ id: 'mcp.verify.intro' })}</IntroText>
      <PromptCopyCard
        text={ prompt }
        copyValue={ prompt }
        leadingIcon={ <SparkIcon /> }
      />
    </Wrapper>
  );
};

export default VerifyConnectionSection;
